window.k1AJAX = {

	sendFavoriteProduct: function (id) {
		let data = {};
		data.goodId = id;
		const url = '/ajax/favorite_goods.php';
		fetch(url, {
			method: 'post',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data),
		}).then(response => {
			return response.json()
		}).then(responseData => {
			console.log(responseData)
			// todo: make success modal
		})
	},

	getHeaderBasketBlock: function (elem) {
		const url = "/ajax/header_cart_items.php";
		fetch(url, {
			method: "post",
			headers: {
				'Content-Type': 'application/json'
			},
			body: ""
		}).then(resolve => {
			return resolve.text();
		}).then(htmlString => {
			let parser = new DOMParser();
			let block = parser.parseFromString(htmlString, "text/html").querySelector(".header__tools-basket-drop-block.drop-block");
			this.putBlockInHeaderBasket(block, elem)
		}).catch(error => {
			console.log(error)
		});
	},

	putBlockInHeaderBasket: function (block, newHome) {
		if (newHome.querySelector(".header__tools-basket-drop-block.drop-block")) {
			newHome.querySelector(".header__tools-basket-drop-block.drop-block").remove()
		}
		block.classList.add("opened");
		// console.log(block)
		newHome.append(block);
	},

	closeHeaderCart: function (block, event) {
		const target = event.target;
		// console.log(block)
		// console.log(target.closest("#header-cart-js"))

		if (block.classList.contains("opened") || !target.closest("#header-cart-js")) {
			block.classList.remove("opened");
			block.querySelector(".header__tools-basket-drop-block.drop-block").remove();

		} else {
			return false
		}
	},

	bindElements: function () {
		// BX.bind(BX("callback-form-button-js"), "click", BX.proxy(this.sendCallBackModal, this))
	},

	sendCallBackModal: function (event) {
		event.preventDefault();
		const formData = window.k1Forms.getCallBackModalData();
		if (!formData) return false;
		const url = "/ajax/callback_form.php";
		formData["K1_CALLBACK_CHECKED"] = 0;
		fetch(url, {
			method: "post",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(formData)
		}).then(response => {
			return response.text();
		}).then(data => {
			const parser = new DOMParser();
			const newDOM = parser.parseFromString(data, "text/html");
			const input = newDOM.querySelector("#data-callback-form");

			// if (input.value === "true") {
			// 	window.k1ScriptComments.showSuccessModal("success-callback-modal-js");
			// }
		}).catch(error => {
			console.log(error)
		})
	},

	init: function () {
		this.bindElements();
	}


};

window.addEventListener('DOMContentLoaded', function (e) {
	window.k1AJAX.init();
});

window.addEventListener('click', function (e) {
	// console.log(e.target);

	// if (e.target.closest('.k1-favorite-js')) window.k1AJAX.sendFavoriteProduct(window.k1ChosenGoods.getProductId(e.target.closest('.k1-favorite-js')))
});





// document.querySelector('.fast-buy-form__button').addEventListener('click', function(e) {
// 	window.k1AJAX.sendDataFastBuyModal(e, window.k1Forms.getDataFastBuyModal(e));
// });


// getBlock: function(block) {
// 	console.log(block)
// 	return block
// },


// sendDataFastBuyModal: function(event) {
// 	event.preventDefault();
// 	const data = window.k1Forms.getDataFastBuyModal(event);
// 	console.log(data)
// 	if (!data) return false;
// 	const url = '/ajax/fast_buy_form.php';
// 	fetch(url, {
// 		method: 'post',
// 		headers: {
// 			'Content-Type': 'application/json'
// 		},
// 		body: JSON.stringify(data),
// 	}).then(response => {
// 		return response.text()
// 	}).then(responseData => {
// 		console.log(responseData);
// 		const parser = new DOMParser();
// 		const newDOM = parser.parseFromString(responseData, "text/html");
// 		const status = newDOM.querySelector("#fast-buy-send-input").value;
// 		if (status === "true") {
// 			window.K1FastBuy.prototype.showSuccessContent()
// 		}
// 		console.log(status)
// 		// console.log(responseData.sent)
// 		// todo: make success modal
// 	})
// },

//order-info__pay-input default-form-input-text default-form-input-text-js
// refreshOrderTotal: function() {
// const url = location.href;
// fetch(url, {
// 	method: "post",
// 	headers: {
// 		"Content-Type": "application/json"
// 	},
// 	body: "refreshOrderAfterChangeQuantity"
// }).then(response => {
// 	return response.text()
// }).then(data => {
// 	let totalOld, totalNew, newDOM, parser;
// 	parser = new DOMParser();
// 	newDOM = parser.parseFromString(data, "text/html");
// 	// console.log("newDOM: ", newDOM)
// 	totalOld = document.getElementById("bx-soa-total");
// 	totalNew = newDOM.getElementById("bx-soa-total");
// 	console.log(newDOM)
// 	// totalOld.before(totalNew);
// 	// totalOld.remove();
// })
// }